import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('~/core/core.module').then((mod) => mod.CoreModule),
    data: {
      key: 'core'
    }
  }
];
